module.exports = __webpack_public_path__ + "img/41_54.c926003d.png";